import React from 'react';
// import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Link } from 'react-router-dom';
import { Col, Button, Row } from 'reactstrap';
import windshield from '../../assets/img/bugzero/windshield.svg';

const Error404 = () => (
  // <Card className="text-center">
  //   <CardBody className="p-5">
  //     <div className="display-1 text-200 fs-error">404</div>
  //     <p className="lead mt-4 text-800 text-sans-serif font-weight-semi-bold">
  //       The page you're looking for is not found.
  //     </p>
  //     <hr />
  //     <p>
  //       Make sure the address is correct and that the page hasn't moved. If you think this is a mistake,
  //       <a href="mailto:info@exmaple.com" className="ml-1">
  //         contact us
  //       </a>
  //       .
  //     </p>
  //     <Link className="btn btn-primary btn-sm mt-3" to="/">
  //       <FontAwesomeIcon icon="home" className="mr-2" />
  //       Take me home
  //     </Link>
  //   </CardBody>
  // </Card>
  <Row>
    <Col sm={6} className="my-auto">
      <h1>Oooops !</h1>
      <h4 className="my-3">In life, sometimes you&apos;re the windshield, sometimes you are the bug</h4>
      <p className="lead">We can&apos;t seem to find the page you are looking for</p>
      <Link to={'/'}>
        <Button color="falcon-primary">Back to home</Button>
      </Link>
    </Col>
    <Col sm={6} className="my-auto">
      <img className="img-fluid mx-auto" src={windshield} alt="Bug or windshield" />
    </Col>
  </Row>
);

export default Error404;
